<script setup lang="ts">
const { direction = 'horizontal-bottom' } = defineProps<{
    direction?: 'horizontal-bottom' | 'horizontal-top' | 'vertical-right' | 'vertical-left'
}>()
const baseAnimationClass = `transition ease-[cubic-bezier(0.645, 0.045, 0.355, 1.000)] duration-[250ms]`
const enterFormClass = {
    'horizontal-bottom': '-rotate-x-90',
    'horizontal-top': 'rotate-x-90',
    'vertical-right': '-rotate-y-90',
    'vertical-left': 'rotate-y-90'
}
const leaveToClass = {
    'horizontal-bottom': 'rotate-x-90',
    'horizontal-top': 'rotate-x-90',
    'vertical-right': 'rotate-y-90',
    'vertical-left': 'rotate-y-90'
}
const enterToClass = {
    'horizontal-bottom': 'rotate-x-0',
    'horizontal-top': 'rotate-x-0',
    'vertical-right': 'rotate-y-0',
    'vertical-left': 'rotate-y-0'
}
const leaveFormClass = {
    'horizontal-bottom': 'rotate-x-0',
    'horizontal-top': 'rotate-x-0',
    'vertical-right': 'rotate-y-0',
    'vertical-left': 'rotate-y-0'
}
</script>

<template>
    <Transition mode="out-in" :enter-active-class="baseAnimationClass" :leave-active-class="baseAnimationClass"
        :enter-from-class="`opacity-0 ${enterFormClass[direction]}`"
        :leave-to-class="`opacity-0 ${leaveToClass[direction]}`" :enter-to-class="enterToClass[direction]"
        :leave-from-class="leaveFormClass[direction]">
        <slot></slot>
    </Transition>
</template>
<style scoped>
.rotate-x-0 {
    transform: rotateX(0deg);
}

.rotate-x-90 {
    transform: rotateX(90deg);
}

.-rotate-x-90 {
    transform: rotateX(-90deg);
}

.rotate-y-0 {
    transform: rotateY(0deg);
}

.rotate-y-90 {
    transform: rotateY(90deg);
}

.-rotate-y-90 {
    transform: rotateY(-90deg);
}
</style>
